<template>
    <v-card>
        <v-toolbar flat color="primary" dark height="40" >
            <v-toolbar-title>Activities</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
            <v-layout row wrap v-if="activities.length">
                <v-flex xs12 pb-2 v-for="activity in activities" :key="activity.id">
                    <div>
                        {{activity.activity}} 
                    </div>
                    <div class="caption text-xs-right pr-5">
                        <i>{{activity.createDate}} By {{activity.createBy}}</i>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        props: ['quoteData'],
        computed: {
            activities () {
                return this.quoteData.activities?this.quoteData.activities:[]
            }
        }
    }
</script>
